import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import SignupProgress from "../../Components/SignupProgress";
import { images } from "../../Assets/images";
import PhoneNumberInput from "../../Components/PhoneNumberInput";

const CreateAccount = () => {
  const {
    email,
    signupData,
    updateSignupData,
    createAccountScreenOne,
    translatedLabels,
    logoUrl,
    verifyAccessCode
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const [isVerified, setIsVerified] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  useEffect(() => {
    const timer = setTimeout(async () => {
      const accessCode = signupData.accessCode?.trim();
      if (!accessCode) {
        setIsVerified(false);
        return;
      }

      setIsVerifying(true);
      const result = await verifyAccessCode(accessCode);
      setIsVerified(result?.status === true);
      setIsVerifying(false);
    }, 800);

    return () => clearTimeout(timer);
  }, [signupData.accessCode, verifyAccessCode]);


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isVerified) {
      window.showToast("error", "Please verify your access code first");
      return;
    }
    createAccountScreenOne();
  };
  return (
    <>
      <section id="createAccountPage" className="login-section-bg">
        <div className="container-main">
          <div className="d-flex justify-content-center">
            <div className="app-logo">
              <img
                src={logoUrl || images.appLogo}
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.appLogo;
                }}
              />
            </div>
          </div>
          <SignupProgress currentStep={1} />
          <h3 className="mb-4 text-center">
            {authLabel?.create_new_account?.label_value || "Create new account"}
          </h3>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="d-flex gap-3 align-items-center mb-2">
              <div className="form-group">
                <label className="form-label">
                  {authLabel?.first_name?.label_value || "First name"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_first_name?.label_value ||
                    "Enter firstname"
                  }
                  value={signupData?.firstName}
                  onChange={(e) =>
                    updateSignupData("firstName", e.target.value.trimStart())
                  }
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  {authLabel?.last_name?.label_value || "Last name"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_last_name?.label_value || "Enter lastname"
                  }
                  value={signupData?.lastName}
                  onChange={(e) =>
                    updateSignupData("lastName", e.target.value.trimStart())
                  }
                />
              </div>
            </div>

            <div className="form-group mb-2">
              <label className="form-label">
                {authLabel?.email?.label_value || "Email"}{" "}
                <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_your_email?.label_value || "Enter e-mail"
                }
                value={email}
                onChange={(e) => updateSignupData("email", e.target.value)}
                disabled
              />
            </div>

            <div className="form-group mb-2">
              <label className="form-label">
                {authLabel?.phone_number?.label_value || "Phone number"}
              </label>

              <PhoneNumberInput
                value={signupData?.phoneNumber}
                onChange={(phoneNumber) => {
                  updateSignupData("phoneNumber", phoneNumber);
                }}
              />
            </div>

            <div className="form-group mb-2">
              <label className="form-label">
                {authLabel?.access_code?.label_value || "Access code"}
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_access_code?.label_value ||
                  "Enter access code"
                }
                value={signupData?.accessCode}
                onChange={(e) =>
                  updateSignupData("accessCode", e.target.value.trimStart())
                }
              />
              {isVerifying && (
                <small className="text-info">{authLabel?.verifying?.label_value || "Verifying access code..."}</small>
              )}
              {!isVerifying && signupData.accessCode && (
                <small
                  className={`${isVerified ? "text-success" : "text-danger"
                    } d-block`}
                >
                  {isVerified
                    ? authLabel?.access_code_verified?.label_value || "Access code verified successfully!"
                    : authLabel?.access_code_invalid?.label_value || "Invalid access code"
                  }
                </small>
              )}
            </div>

            <div className="mt-4 text-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!isVerified || isVerifying}
              >
                {authLabel?.next?.label_value || "Next"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default CreateAccount;
